module.exports = __webpack_public_path__ + "static/media/DMSans-Bold.1497b711.eot";